import { createContext, useContext } from 'react';

const FunnelContext = createContext(null);

export const useFunnel = () => {
  const context = useContext(FunnelContext);
  if (!context) {
    throw new Error('useFunnel must be used within a FunnelProvider');
  }
  return context;
};

export default FunnelContext;
